<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    title="Zmiana adresu skrytki ePUAP wnioskodawcy"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="submit"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-12">
        <w-input :model="$schema.value" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { DocumentValueCodes } from '@/enums/documentValueCodes.enum';
import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/epuapAddress.schema';
import { getDocumentViewData } from '@/utils/document';
import { serverError } from '@/utils/serverError';

// @vuese
// Modal modyfikacji adresu skrytki epuap
// @group Modals
export default {
  mixins: [formMixin, notificationsMixin],
  props: {
    // Czy widoczny
    show: { type: Boolean },
    // Dokument
    documentIndex: { type: Object, required: true }
  },
  schema,

  beforeMount() {
    this.$schema.$setData({
      code: DocumentValueCodes.EPUAP_ADDRESS,
      documentId: parseInt(this.$route.params.documentId),
      value: this.documentIndex.values?.[DocumentValueCodes.EPUAP_ADDRESS]
    });
  },

  methods: {
    // @vuese
    // Zapis adresu
    submit() {
      if (this.$schema.$validateAll().length) {
        this.notifyError(Errors.FORM_CORRECT_ERRORS);
        return;
      }

      this.$store
        .dispatch('documentValue/add', this.$schema.$getData())
        .then(() => {
          this.notifySuccess(Successes.EPUAP_SAVED);
          this.close();
          getDocumentViewData(this.$route);
        })
        .catch(err => this.notifyError(serverError(err)));
    },

    // @vuese
    // Zamknięcie modala
    close() {
      this.$emit('close');
    }
  }
};
</script>
